module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2021_28.693f1f35.jpg";